// @flow
import BaseModel from 'Stores/BaseModel';
import ListModel from 'Stores/ListModel';
import AssetModel from 'Stores/AssetModel';
import { validateLength, validateEmail, isInvalid } from 'Utils/Validators';
import axios from 'axios';

declare var API_BASE_URL: string;

export default class EmployeeModel extends BaseModel {
  static departments = [
    { value: 1, label: 'Verkauf' },
    { value: 2, label: 'Service' },
    { value: 3, label: 'Werkstatt' },
    { value: 4, label: 'Geschäftsleitung' },
    { value: 5, label: 'Marketing' },
    { value: 6, label: 'Buchhaltung' },
    { value: 7, label: 'Verwaltung' },
    { value: 8, label: 'Assistenz' },
  ];

  static departmentSorting = [4, 1, 2, 3, 5, 6, 7, 8];

  id: number = 0;
  firstname: string = '';
  lastname: string = '';
  jobTitle: string = '';
  department: number = 1;
  phone: string = '';
  email: string = '';
  hidden: boolean = true;
  image: ?AssetModel = null;
  sortIndex: number = 0;

  constructor(data: Object = {}) {
    super();
    this.hydrate(data);

    this.image = data.image ? new AssetModel(data.image) : null;
  }

  valid = () => {
    this.errors = {};
    validateLength(this.errors, 'firstname', this.firstname, 1, 32);
    validateLength(this.errors, 'lastname', this.lastname, 1, 32);
    validateLength(this.errors, 'jobTitle', this.jobTitle, 1, 64);

    if (this.phone) {
      validateLength(this.errors, 'phone', this.phone, 1, 64);
    }

    if (this.email) {
      validateEmail(this.errors, 'email', this.email);
    }

    return !isInvalid(this.errors);
  };

  fullname() {
    return `${this.firstname} ${this.lastname}`;
  }

  toListItem() {
    const subline = [this.getLabel('departments', this.department)];
    this.phone && subline.push(this.phone);
    this.email && subline.push(this.email);

    return {
      id: this.id,
      index: this.sortIndex,
      headline: this.fullname(),
      subline: subline.join(' | '),
      hidden: this.hidden,
      image: this.image,
      model: this,
    };
  }

  save = () => {
    if (this.id > 0) {
      return axios.patch(`${API_BASE_URL}/team/${this.id}/`, this.toJSON()).then((res) => {
        return new EmployeeModel(res.data);
      });
    }

    return axios.post(`${API_BASE_URL}/team/`, this.toJSON()).then((res) => {
      return new EmployeeModel(res.data);
    });
  };

  static saveCurrentOrder = (items) => {
    axios.patch(`${API_BASE_URL}/team-departments/`, {
      // Transform request payload to fit api requirements
      teamSorting: items.map((item, i) => {
        return {
          id: item.id,
          sortIndex: ++i,
        };
      }),
    });

    return items.map((item, i) => {
      item.model.sortIndex = ++i;
      return item.model;
    });
  };

  delete = () => {
    return axios.delete(`${API_BASE_URL}/team/${this.id}/`);
  };

  toJSON = () => {
    const json: Object = {
      firstname: this.firstname,
      lastname: this.lastname,
      salutation: '',
      gender: '',
      jobTitle: this.jobTitle,
      department: this.department,
      phone: this.phone,
      email: this.email,
      hidden: this.hidden,
      image: this.image,
    };

    if (!this.isNew()) {
      json.id = this.id;
    }

    return json;
  };

  static getAll = (params: Object = {}) => {
    return axios({
      method: 'get',
      url: `${API_BASE_URL}/team/`,
      params,
    }).then((res: { data: Array<Object> }) => {
      return new ListModel(res.data, EmployeeModel);
    });
  };
}
